var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import classNames from 'classnames';
import { default as React, useCallback } from 'react';
import { Button, ButtonMode, ButtonVariant } from '../../Components/Button';
import { useField } from '../../Components/useForm/useField';
import { dosageTimesBedtimeAndNight, dosageTimesBreakfastAndMorning, dosageTimesDinner, dosageTimesLunchAndAfternoon } from '../../Shared/Constants';
import { divider, primary } from '../../Styles/Colours';
import styles from './EditDosageTimeSelector.module.css';
var timeBlocks = [
    {
        name: 'Breakfast & morning',
        times: dosageTimesBreakfastAndMorning
    },
    {
        name: 'Lunch & afternoon',
        times: dosageTimesLunchAndAfternoon
    },
    {
        name: 'Dinner & bedtime',
        times: dosageTimesDinner
    },
    {
        name: 'Night-time',
        times: dosageTimesBedtimeAndNight
    }
];
function DosageTimeButton(props) {
    var _a;
    var active = props.times.includes(props.value);
    var item;
    if (props.readOnly) {
        item = (React.createElement("div", { className: classNames(styles.readOnlyDosageTime, (_a = {},
                _a[styles.active] = active,
                _a)) }, props.value));
    }
    else {
        item = (React.createElement(Button, { mode: active ? ButtonMode.solid : ButtonMode.border, onClick: function () {
                props.onClick(props.value);
            }, testId: "time-" + props.value, borderColour: active ? primary : divider, variant: active ? ButtonVariant.primary : ButtonVariant.light, style: { borderRadius: '2px', height: '32px', fontSize: '14px' }, width: '100%' }, props.value));
    }
    return React.createElement("div", { className: styles.dosageTimeButton }, item);
}
var DosageTimes = function (props) { return (React.createElement("div", { className: styles.timeBlock },
    React.createElement("div", { className: styles.label }, props.timeBlock.name),
    props.timeBlock.times.map(function (time) { return (React.createElement(DosageTimeButton, { key: time, readOnly: props.readOnly, times: props.times, value: time, onClick: props.onClick })); }))); };
function areDosageTimesEqual(prevProps, nextProps) {
    var _a, _b;
    if (prevProps.readOnly !== nextProps.readOnly)
        return false;
    return ((_a = prevProps.times) === null || _a === void 0 ? void 0 : _a.length) === ((_b = nextProps.times) === null || _b === void 0 ? void 0 : _b.length);
}
var DisplayDosageTimes = React.memo(DosageTimes, areDosageTimesEqual);
export function EditDosageTimeSelectorForm(props) {
    // This overload lets you return an explicit form type.
    // Should only be used for nested properties
    var timesField = useField({
        form: props.form,
        field: props.fieldPath + ".times"
    });
    function timeSelectorChanged(times) {
        props.onChange(times);
        timesField.setValue(times);
    }
    return React.createElement(EditDosageTimeSelector, { readOnly: props.readOnly, times: timesField.value, onChange: timeSelectorChanged });
}
export var EditDosageTimeSelector = function (props) {
    var handleTimeClick = useCallback(function (time) {
        if (props.times.includes(time)) {
            var index = props.times.indexOf(time);
            var newTimes = __spreadArray([], __read(props.times), false);
            newTimes.splice(index, 1);
            props.onChange(newTimes);
        }
        else {
            var strings = __spreadArray(__spreadArray([], __read(props.times), false), [time], false).sort();
            props.onChange(strings);
        }
    }, [props.times]);
    return (React.createElement("div", { className: styles.timeBlocks }, timeBlocks.map(function (timeBlock) { return (React.createElement(DisplayDosageTimes, { readOnly: props.readOnly, key: timeBlock.name, timeBlock: timeBlock, times: props.times, onClick: handleTimeClick })); })));
};
